import React from "react";
import { useLocation } from "react-router-dom";
import StablePrime from "../../components/Tables/StablePrime";




function FourMSupportingDocStable({ setPageHeader, docId }) {
  // const { docNo } = useParams();
  const { search } = useLocation();
  const docNo = new URLSearchParams(search).get("id") || docId;
  if(setPageHeader){
    setPageHeader("FourM Supporting Documents");
  }
  return (
    <div>
      {/* <StablePrime url="qc/auditsession" data={{typ: "fourm",  event: docNo }} identity="perfparam" /> */}
      <StablePrime editSingleColumn={true} zenTable={true} url={"qc/auditsession"} data={{typ: "fourm",  event: docNo }} identity="DataTable" />

    </div>
  );
}

export default FourMSupportingDocStable;
